/**
 * ルート進入前の先回りモーダルの文言: 通話ルート。
 * 見た目は通話 pt 不足の文脈モーダルと同じ（CallPromptDialog）で、形も byTrigger（bubble / lead / cta）に揃える。
 * 見出し（lead）と CTA で一文が完結する。要るポイントは注記で正直に添える。
 * （2026-10-09 たたき案。ユーザーが後で直す前提）
 */
export const preroutePromptCall = {
  byTrigger: {
    /** 消費直前: 発信・通話リクエストして止まった（同じ種別でかけ直す） */
    call: {
      bubble: "かけてくれたよね…？もう一回♡",
      lead: (args: { name: string | number }) => `${args.name}さんに`,
      cta: "通話する",
    },
    /**
     * まだかけていない人（物色・通話確認モーダルを閉じただけ）: ビデオ通話。最初の一歩を小さく見せる（まずは 1 分。250pt でビデオ通話は約 1 分）
     * ＋相手がいま受付中という事実（いま空いてる）。偽の締め切り・無料に見える言い方は使わない（2026-10-14 ユーザー決定）
     */
    video_call: {
      bubble: "いま空いてるよ…ちょっとだけ話そ？",
      lead: (args: { name: string | number }) => `まずは1分 ${args.name}さんと`,
      cta: "ビデオ通話する",
    },
    /** まだかけていない人: 音声通話（ビデオと同じ考え方） */
    voice_call: {
      bubble: "声だけでも話そ…？",
      lead: (args: { name: string | number }) => `まずは1分 ${args.name}さんと`,
      cta: "音声通話する",
    },
  },
  /** CTA 下の注記: 1 分あたりのポイント（手持ちで話せる時間は出さない。2026-10-09 ユーザー指定） */
  noteVideo: (args: { point: string | number }) =>
    `ビデオ通話 ${args.point}pt/分`,
  noteVoice: (args: { point: string | number }) =>
    `音声通話 ${args.point}pt/分`,
  photoAlt: (args: { name: string | number }) => `${args.name}さんの写真`,
  close: "閉じる",
} as const;
